import React, { useState, Fragment } from 'react';
import './PublishersComponent.scss';
import moment from 'moment';
// import Table from './Table/Table';
import Table from '../../shared/SemanticTable/Table';
import useCells from './useCells';
import Tabs from './Tabs';

const PublishersComponent = ({
  resetReducer,
  getPublishers,
  PublishersReducer,
  getPublishersLast,
  data,
  pending,
  filtered,
  status, provider
}) => {
  const [activeItem, setActiveItem] = useState('Date');
  const [cells] = useCells(data, activeItem);

  return (
    <Fragment>
      <Tabs
        getPublishers={getPublishers}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        provider={provider}
      />
      <Table
        cells={cells}
        data={data}
        action
        type="publisher"
        isLoading={pending}
        filtered={filtered}
        // getItems={infiniteScroll}
        infinite
        // pagination={pagination}
        dataStatus={status}
        resetTableState={resetReducer}
        // filters={this.state.filters}
      />
    </Fragment>
  );
};

export default PublishersComponent;
